<era-security-user-list-item-ui [user]="user()"
                                [isEditing]="isEditing()"
                                (deleteEvent)="deleteEvent($event)"></era-security-user-list-item-ui>